import { CircleOff, Gift, Store, MessageCircle } from "lucide-react";
import { GlassCard, SectionHeading } from "./GlassCard";

const points = [
  {
    icon: CircleOff,
    title: "No revenue-share fees",
    desc: "Flat subscription, zero commission cuts. Jo kamaya, woh aapka — every rupee of every order stays with you.",
  },
  {
    icon: Gift,
    title: "Free 90-day trial",
    desc: "Full command center access for 90 days, up to 10 products free. No credit card, no conditions.",
  },
  {
    icon: Store,
    title: "Multi-outlet support",
    desc: "Ek se zyada dukaanein? Manage every outlet, catalogue and QR from a single Gromza account.",
  },
  {
    icon: MessageCircle,
    title: "Priority WhatsApp help",
    desc: "Real humans on WhatsApp, not bots. Setup, listings, payments — help arrives in minutes.",
  },
];

const testimonials = [
  {
    quote: "2 minute me meri dukaan online thi. Ab 3 km ke customers roz naye orders bhejte hain — QR scan karke seedha catalog kholte hain.",
    name: "Vikash Kumar",
    role: "Jeweller · Patna",
  },
  {
    quote: "₹49 ka Standard ad chalaya aur weekend me footfall double. Wallet se paisa kata, dashboard pe result dikha. Simple.",
    name: "Priya Sharma",
    role: "Fashion Boutique · Muzaffarpur",
  },
  {
    quote: "GST invoices, Shiprocket shipping, analytics — sab ek app me. Referral se mujhe 60 din free mile ab tak.",
    name: "Rahul Verma",
    role: "Electronics Store · Hajipur",
  },
];

export const Advantage = () => (
  <>
    <section id="advantage" data-testid="advantage-section" className="relative py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHeading
          testId="advantage-heading"
          eyebrow="The Gromza Advantage"
          title="Why shopkeepers"
          highlight="choose Gromza."
        />
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {points.map((p, i) => (
            <GlassCard key={p.title} testId={`advantage-card-${i}`} delay={i} className="p-8 group">
              <div className="w-12 h-12 rounded-xl bg-amber-400/10 border border-amber-400/20 flex items-center justify-center mb-6 group-hover:bg-amber-400/20 transition-colors duration-400">
                <p.icon size={22} className="text-amber-400" />
              </div>
              <h3 className="font-display text-lg font-semibold mb-3">{p.title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{p.desc}</p>
            </GlassCard>
          ))}
        </div>
      </div>
    </section>

    <section data-testid="testimonials-section" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHeading
          testId="testimonials-heading"
          eyebrow="Merchant Stories"
          title="Dukaandar bole,"
          highlight="growth bole."
          align="center"
        />
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <GlassCard key={t.name} testId={`testimonial-card-${i}`} delay={i} className="p-8 flex flex-col">
              <span className="font-display text-5xl gold-text leading-none mb-5">&ldquo;</span>
              <p className="text-sm text-slate-300 leading-relaxed flex-1">{t.quote}</p>
              <div className="mt-7 pt-5 border-t border-white/[0.08]">
                <p className="font-display text-base font-semibold">{t.name}</p>
                <p className="text-xs text-slate-500 mt-0.5">{t.role}</p>
              </div>
            </GlassCard>
          ))}
        </div>
      </div>
    </section>
  </>
);
